import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { PersonSearchViewModel } from "../../personSearch-viewModel";
import { AttachmentListSelectorViewModel } from "../attachmentListSelector/attachmentListSelector-viewModel";
import  { CreatePaymentRequestView } from "./createPaymentRequest-view"

export class CreatePaymentRequestViewModel extends WindowViewModel implements IPopup{
    public getTitle(): string {
        return 'ثبت درخواست پرداخت';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    
        this._serverUpdater = new InsertServerSaver();
        this.reasons = ObservableArray.create<reason>();
        this.reasons.update(...[new reason(this,1),new reason(this,2),new reason(this,3)]);
        this.personSelector = new PersonSearchViewModel(this);
        this.closePopup = null;
        this.personSelector.onSelectionChanged= x=>{
            if(x==null){
                this.selectedPersonId = null;
                this.selectedPersonCode = "",
                this.selectedPersonName = "";
            }else{
                this.selectedPersonId = x.id;
                this.selectedPersonCode = x.code,
                this.selectedPersonName = x.name;
            }
        }
        this.attachments = new AttachmentListSelectorViewModel(this);
    }
    closePopup(resultCode: string) {}

    GetDefaultView(): View <ViewModel> {
        return new CreatePaymentRequestView();
    }
    public getTypeId(): string {
        return "VM-5DB73824-E7E7-4D43-BF90-9BA48E75BA20"
    }

    
    private _serverUpdater : IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personSelector(v: PersonSearchViewModel) { this._personSelector = v; } public get personSelector(): PersonSearchViewModel { return this._personSelector;} private _personSelector: PersonSearchViewModel;
    public set amount(v: number) { this._amount =getAsNumber(v); } public get amount(): number { return this._amount;} private _amount: number;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set reasons(v: ObservableArray<reason>) { this._reasons = v; } public get reasons(): ObservableArray<reason> { return this._reasons;} private _reasons: ObservableArray<reason>;
    public set selectedReason(v: reason) { this._selectedReason = v; } public get selectedReason(): reason { return this._selectedReason;} private _selectedReason: reason;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments;} private _attachments: AttachmentListSelectorViewModel;
        
    public set selectedPersonId(v: string) { this._selectedPersonId = v; } public get selectedPersonId(): string { return this._selectedPersonId;} private _selectedPersonId: string;
    public set selectedPersonName(v: string) { this._selectedPersonName = v; } public get selectedPersonName(): string { return this._selectedPersonName;} private _selectedPersonName: string;
    public set selectedPersonCode(v: string) { this._selectedPersonCode = v; } public get selectedPersonCode(): string { return this._selectedPersonCode;} private _selectedPersonCode: string;
    

    async save(){
        let validationResult: string[] = this.validationInformation();
        if (validationResult.length != 0){
            await this.messageBoxConfirmWarning(validationResult.join('\r\n'), 'خطا');
        }
        else{
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.Update(this);
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess(`درخواست با کد ${result.Code} ثبت شد`,'ثبت درخواست پرداخت');
                    await this.tryClose(false,'yes');
                    this.close();
                }else{
                    await this.messageBoxConfirmWarning('خطا در ثبت درخواست پرداخت','خطا');
                }
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت درخواست پرداخت','خطا');
            } finally {
                this.isLoading = false;
            }
        }
    }
    closeWindow(msg:string){
        this.tryClose(true,msg,'آیا از بستن صفحه اطمینان دارید؟','خروج');
    }
    public loadById(id:string){

    }

    validationInformation(): string[] {
        let result: string[] = [];
        if (this.personSelector.selectedItem == null) result.push('گیرنده مشخص نشده است.');
        if (this.personSelector.selectedItem != null && stringIsNullOrEmpty(this.selectedPersonName)) result.push('نام گیرنده به درستی مشخص نشده است.');
        if (this.amount == null) result.push('مبلغ وارد نشده است.');
        if (this.selectedReason == null) result.push('نوع پرداخت مشخص نشده است.');
        if (this.comment == null) result.push('علت پرداخت (فیلد بابت) مشخص نشده است.');
        return result;
    }
}
interface IServerUpdater{
    Update(vm:CreatePaymentRequestViewModel):Promise<any>;
}

class InsertServerSaver implements IServerUpdater{
    async Update(vm: CreatePaymentRequestViewModel): Promise<any> {
        let result = await ServerConnection.callServer('Complex/PaymentProcessServices/CreatePaymentRequest',{
            PersonId:vm.selectedPersonId,
            Amount:vm.amount,
            RequestType:vm.selectedReason.id,
            Comment:vm.comment,
            Attachments:vm.attachments.getAttachments().map(x=>{
                return {
                    Name:x.name,
                    Data:x.content
                }
            })
        });
        return result;
    }

}
class ServerUpdater implements IServerUpdater{
    Update(vm: CreatePaymentRequestViewModel): Promise<any> {
        throw new Error("Method not implemented.");
    }

}

export class reason extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:number) {
        super(parent);
        this.id = id;
        this.name = new TranslatorConverter().paymentProcessTypeNameConverter(id);
    }
    public set id(v: number) { this._id = v; } public get id(): number { return this._id;} private _id: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}

